import axios from "../api";

export const getRoleAction = (roleName, isForDropdown = false) => {
    return new Promise((resolve, reject) => {
        axios
            .post("/api/role/list", { roleName, isForDropdown })
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const createRoleAction = (data) => {
    return new Promise((resolve, reject) => {
        axios
            .post(`/api/role/create`, data)
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                // throw error.response?.data ?? error;
                reject(error);
            });
    });
};

export const editRoleAction = async (roleId, data) => {
    return new Promise((resolve, reject) => {
        axios
            .post(`/api/role/edit/${roleId}`, data)
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const getRoleByIdAction = async (id) => {
    return new Promise((resolve, reject) => {
        axios
            .get(`api/role/view/${id}`)
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const getRoleByPermissionAction = async (id) => {
    return new Promise((resolve, reject) => {
        axios
            .get(`api/role/get-roles-permisssionByName`)
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const deleteRoleAction = async (id) => {
    return new Promise((resolve, reject) => {
        axios
            .post(`/api/role/delete/${id}`)
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const getModuleListAction = () => {
    return new Promise((resolve, reject) => {
        axios
            .get("/api/role/modules/list")
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
};
